import { APPLICANT_AUTOMATION_COMMUNICATION_TYPES } from './applicant-automation-communication-types';

export const isApplicantAutomation = (
  automation: ApplicantAutomation | StartDateTriggeredCommunication,
): automation is ApplicantAutomation =>
  Boolean(
    Object.values(APPLICANT_AUTOMATION_COMMUNICATION_TYPES).includes(
      automation.communicationType as ApplicantAutomationCommunicationType,
    ) && (automation as ApplicantAutomation).applicantTriggeredCommunicationId,
  );

export const isApplicantAutomationJobOverride = (
  automation: ApplicantAutomation,
): automation is ApplicantAutomationJobOverride => !!automation.jobId;

export const isApplicantAutomationOrCopy = (
  automation:
    | ApplicantAutomationCopy
    | StartDateTriggeredCommunicationCopy
    | ApplicantAutomation
    | StartDateTriggeredCommunication,
): automation is ApplicantAutomationCopy | ApplicantAutomation =>
  Object.values(APPLICANT_AUTOMATION_COMMUNICATION_TYPES).includes(
    automation.communicationType as ApplicantAutomationCommunicationType,
  );

export const isExistingApplicantAutomation = (
  automation:
    | ApplicantAutomation
    | Partial<ApplicantAutomation>
    | Partial<ApplicantAutomationCopy>
    | null
    | undefined,
): automation is ApplicantAutomation =>
  !!automation && !!automation.applicantTriggeredCommunicationId;
